import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Building2 } from "lucide-react";
import OtpLogin from "@/components/OtpLogin";
import { useOpenDestination } from "@/lib/signIn";
import { TEST_NUMBERS } from "@/lib/testAccounts";

/**
 * /t/<slug>/admin/login. The same sign-in as everywhere else, on this tenant.
 * A number that is this tenant's admin opens the admin console. Any other
 * number goes to what it does have here; it never becomes an admin.
 */
export default function TAdminLogin() {
  const { slug } = useParams();
  const open = useOpenDestination();

  const onSignedIn = (session) => {
    if (session.destination.role !== "tenant_admin") toast.info("This number is not an admin of this business.");
    open(session);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5] admin-body p-4 sm:p-6">
      <div className="w-full max-w-md bg-white border border-neutral-200 p-6 sm:p-8" data-testid="tadmin-login-card">
        <Building2 className="h-6 w-6 mb-2" />
        <div className="admin-overline break-anywhere">Tenant /{slug}</div>
        <h1 className="admin-heading text-3xl sm:text-4xl font-bold tracking-tight mt-1">Run your shop.</h1>
        <p className="text-sm text-neutral-500 mt-2">Sign in to your business dashboard with your mobile number.</p>
        <div className="mt-8">
          <OtpLogin key={slug} slug={slug} prefer="tenant_admin" look="console" testid="tadmin-login" onSignedIn={onSignedIn} testNumbers={TEST_NUMBERS} />
        </div>
      </div>
    </div>
  );
}
